import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';

import { ApiError, DataTablesService, MessageService, GuidService } from '../../../core';
import { ItemCrudHttpService } from '../services';
import { Item } from '../item';
import { ItemFilterSearch } from './item-filter-search';

@Component({
    selector: 'sgt-item-filter-modal',
    templateUrl: './item-filter-modal.component.html',
    styleUrls: ['./item-filter-modal.component.less']
})
export class ItemFilterModalComponent implements OnInit {
    @Input() idModal: string;
    @Output() selectEntity = new EventEmitter<Item>();
    elModal: any;
    @Input() exibirDataUltimoFaturamento = false;
    // isSelectRegistered = false;

    entities: Item[];
    idDataTable: string;
    dataTable: any;
    // @ViewChild('modalBody') modalBody: ElementRef;

    // Filter
    filter: ItemFilterSearch;
    orderBy: number;
    orderByDir: string;


    constructor(private el: ElementRef,
                private dataTablesService: DataTablesService,
                private messageService: MessageService,
                private itemCrudHttpService: ItemCrudHttpService,
                private guidService: GuidService,
                private datePipe: DatePipe) { }

    ngOnInit() {
        this.create();
        this.idDataTable = this.guidService.generate();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    open(filter: ItemFilterSearch = null) {
        this.filter = filter ? filter : new ItemFilterSearch();

        // Criando o dataTable assincrono caso ainda não estiver sido criado
        if (!this.dataTable) {
            this.createTable()
                .then()
                .catch();
        } else {
            this.search();
        }

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    // private afterSearch() {
    //     this.filterCollapse.close();
    //     jQuery(this.modalBody.nativeElement).scrollTop(0);
    // }

    search() {
        this.dataTable.ajax.reload();
    }

    /** Cria a Datatables assíncrona */
    createTable(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.dataTablesService.showTable(`#${this.idDataTable}`, this.dataTable, {
                serverSide: true,
                processing: true,
                columns: [
                    {data: 'codigoIntegracaoErp', className: 'col-codigo-integracao-erp'},
                    {
                        data: 'nome',
                        className: 'col-nome',
                        createdCell: (td, cellData, rowData, row, col) => {
                            if (cellData) {
                                td.title = cellData;
                            }
                        }
                    },
                    {
                        data: 'situacao',
                        className: 'col-situacao text-center',
                        render: (data) => {
                            switch (data) {
                                case 1:
                                    return '<span class="badge badge-success">Ativo</span>';
                                case 2:
                                    return '<span class="badge badge-danger">Inativo</span>';
                                default:
                                    return '';
                            }
                        }
                    },
                    {
                        data: 'dataUltimoFaturamento',
                        className: 'col-data-ultimo-faturamento text-center',
                        render: (data) => this.datePipe.transform(data, 'dd/MM/yyyy'),
                        visible: this.exibirDataUltimoFaturamento
                    },
                ],
                ajax: (data, callback, settings) => { // Evento Ajax para pesquisar os itens
                    // this.closeFilter();
                    const order = data.order[0];
                    this.filter.filterPsq = data.search.value;
                    this.orderBy = order.column;
                    this.orderByDir = order.dir;
                    this.itemCrudHttpService.searchWithFilter(this.filter, data.draw, data.start, data.length, order.column, order.dir)
                        .subscribe(
                            response => {
                                this.entities = response.data;
                                callback(response);
                            },
                            (error: ApiError) => {
                                this.messageService.error(error.message, 'Erro ao pesquisar os itens', error);
                                callback({recordsTotal: 0, recordsFiltered: 0, data: []});
                            }
                        );
                }
            })
            .then(dataTable => {
                this.dataTable = dataTable;

                // Registrando o evento de click
                const self = this;
                $(`#${this.idDataTable} tbody`).on('click', 'tr', function() {
                    const item = self.dataTable.row( this ).data() as Item;
                    if (item) {
                        self.onSelectEntity(item);
                    }
                });
                setTimeout(() => resolve(), 500);
            });
        });
    }

    /** Ao selecionar o Item emitimos o evento de seleção e fechamos o modal */
    onSelectEntity(entity: Item) {
        this.selectEntity.emit(entity);
        this.close();
    }
}
